const EMBED_BASE = 'https://www.youtube-nocookie.com/embed/'

/**
 * Converts a YouTube watch/short URL from the CSV into a privacy-friendly
 * embed URL. Returns null for "N/A", empty, or any non-YouTube/unparseable
 * input so the Featured Video section can be hidden.
 */
export const getYouTubeEmbedUrl = (rawUrl?: string): string | null => {
  if (!rawUrl || rawUrl.trim() === '' || rawUrl.trim() === 'N/A') {
    return null
  }

  let parsed: URL
  try {
    parsed = new URL(rawUrl.trim())
  } catch {
    return null
  }

  const host = parsed.hostname.replace(/^www\./, '')

  let videoId: string | null = null
  if (host === 'youtube.com' || host === 'm.youtube.com') {
    videoId = parsed.searchParams.get('v')
  } else if (host === 'youtu.be') {
    videoId = parsed.pathname.slice(1) || null
  }

  if (!videoId) {
    return null
  }

  return `${EMBED_BASE}${videoId}`
}
